import React, { Component } from 'react';
import { BrowserRouter, Route, Link, HashRouter, IndexRoute } from 'react-router-dom';

import Theme from '../layouts/Theme';
import Login from '../views/Login';
import Dashboard from '../views/Dashboard';

import PostCategory from '../views/Settings/PostCategory';
import Qualification from '../views/Settings/Qualification';
import Subject from '../views/Settings/Subject';
import University from '../views/Settings/University';
import SpecialTraining from '../views/Settings/SpecialTraining';
import Renewmonth from '../views/Settings/Renew';

import Registration from '../views/Candidate/Registration';
import AddCandidate from '../views/Candidate/Registration/Add';
import EditCandidate from '../views/Candidate/Registration/Edit';
import Renewal from '../views/Candidate/Renewal';

import AddVacancy from '../views/Appointment/AddVacancy';
import Interview from '../views/Appointment/Interview';
import AppOrder from '../views/Appointment/Order';

import ManageRoles from '../views/ManageRoles';
import NotFound from '../views/NotFound';

import Roles from '../utils/Roles';

import Zones from '../views/Settings/Zones';
import Services from '../views/Settings/Services';
import Institutions from '../views/Settings/Institutions';


const AppRoute = ({ component: Component, layout: Layout, ...rest }) => (
	<Route {...rest} render={props => (
		<Layout>
			<Component {...props} />
		</Layout>
	)} />
)

export default () => (

	<HashRouter>
		<div>

			{/*<Route path="/" exact component={Test} />*/}
			<Route path="/" exact component={Login} />
			<AppRoute path="/dashboard" exact layout={Theme} component={Dashboard} />

			<AppRoute path="/candidate/list" exact layout={Theme}
				component={Roles.Can('candidate', 'registration', 'canuse') ? Registration : NotFound} />

			<AppRoute path="/candidate/registration" exact layout={Theme}
				component={Roles.Can('candidate', 'registration', 'canadd') ? AddCandidate : NotFound} />

			<AppRoute path="/candidate/edit/:id" exact layout={Theme}
				component={Roles.Can('candidate', 'registration', 'canedit') ? EditCandidate : NotFound} />

			<AppRoute path="/candidate/renewal" exact layout={Theme}
				component={Roles.Can('candidate', 'registration', 'canuse') ? Renewal : NotFound} />

			<AppRoute path="/appointment/addvacancy" exact layout={Theme}
				component={Roles.Can('appointment', 'interview', 'canuse') ? AddVacancy : NotFound} />

			<AppRoute path="/appointment/interview" exact layout={Theme}
				component={Roles.Can('appointment', 'interview', 'canuse') ? Interview : NotFound} />

			<AppRoute path="/appointment/order" exact layout={Theme}
				component={Roles.Can('appointment', 'interview', 'canuse') ? AppOrder : NotFound} />

			<AppRoute path="/settings/postcategory" exact layout={Theme}
				component={Roles.Can('settings', 'postcategory', 'canuse') ? PostCategory : NotFound} />

			<AppRoute path="/settings/qualification" exact layout={Theme}
				component={Roles.Can('settings', 'qualification', 'canuse') ? Qualification : NotFound} />

			<AppRoute path="/settings/subject" exact layout={Theme}
				component={Roles.Can('settings', 'subject', 'canuse') ? Subject : NotFound} />

			<AppRoute path="/settings/university" exact layout={Theme}
				component={Roles.Can('settings', 'university', 'canuse') ? University : NotFound} />

			<AppRoute path="/settings/specialtraining" exact layout={Theme}
				component={Roles.Can('settings', 'specialtraining', 'canuse') ? SpecialTraining : NotFound} />

			<AppRoute path="/settings/renewmonth" exact layout={Theme}
				component={Roles.Can('settings', 'renew', 'canuse') ? Renewmonth : NotFound} />

			<AppRoute path="/settings/zones" exact layout={Theme} component={Zones} />
			<AppRoute path="/settings/services" exact layout={Theme} component={Services} />
			<AppRoute path="/settings/institutions" exact layout={Theme} component={Institutions} />

			<AppRoute path="/manageroles" exact layout={Theme} component={ManageRoles} />

		</div>
	</HashRouter>

);